import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ProtectedRoute } from './components/auth';
import { MainLayout } from './components/layout';

// Pages
// import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { VerifyEmail } from './pages/VerifyEmail';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { Dashboard } from './pages/Dashboard';
import { Clients } from './pages/Clients';
import { Servers } from './pages/Servers';
import { Query } from './pages/Query';
import { Settings } from './pages/Settings';
import APIKeysPage from './pages/APIKeysPage';
import { Prompts } from './pages/Prompts';
import { PromptsManagement } from './pages/PromptsManagement';
import { ToolsManagement } from './pages/ToolsManagement';
import { Graph } from './pages/Graph';
import Resources from './pages/Resources';

function RootRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // If user is logged in, redirect to dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  // If not logged in, redirect to login
  return <Navigate to="/login" replace />;
}

function AppRoutes() {
  const { user, logout } = useAuth();

  return (
    <Routes>
      {/* Root route - redirect based on auth status */}
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Protected routes */}
      <Route
        element={
          <ProtectedRoute>
            <MainLayout user={user} onLogout={logout} />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/servers" element={<Servers />} />
        <Route path="/query" element={<Query />} />
        <Route path="/prompts" element={<PromptsManagement />} />
        <Route path="/prompts/legacy" element={<Prompts />} />
        <Route path="/tools" element={<ToolsManagement />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/graph" element={<Graph />} />
        <Route path="/api-keys" element={<APIKeysPage />} />
        <Route path="/settings" element={<Settings />} />
      </Route>

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
